<template>
  <div>
    <div class="flex flex-col-reverse gap-y-1 lg:mt-10 lg:flex-row lg:gap-x-2 lg:gap-y-0">
      <BaseButtonGroup class="hidden w-full lg:flex" size="L">
        <BaseTextButton
          v-for="scaleUnit in scale.items"
          :key="scaleUnit.value"
          size="L"
          color="filled"
          shape="round"
          class="text-title-small! shrink! basis-full px-4! whitespace-normal!"
          :toggle="true"
          :selected="feedbackValue == scaleUnit.value"
          @click.stop.prevent="updateValue(scaleUnit.value)"
          >{{ scaleUnit.label }}</BaseTextButton
        >
      </BaseButtonGroup>
      <BaseButtonGroup class="shrink-0 lg:hidden" size="M" direction="vertical">
        <BaseTextButton
          v-for="scaleUnit in scale.items"
          :key="scaleUnit.value"
          size="S"
          color="filled"
          shape="round"
          class="shrink-0"
          :toggle="true"
          :selected="feedbackValue == scaleUnit.value"
          @click.stop.prevent="updateValue(scaleUnit.value)"
          >{{ scaleUnit.label }}</BaseTextButton
        >
      </BaseButtonGroup>
    </div>
  </div>
</template>
<script setup lang="ts">
  import BaseButtonGroup from '../../../../core/components/base/button/BaseButtonGroup.vue'
  import BaseTextButton from '../../../../core/components/base/button/text-button/BaseTextButton.vue'
  import type { ButtonScale } from '../../../../core/models/scale'

  interface Props {
    scale: ButtonScale
    identifier: string
    disabled?: boolean
  }

  defineProps<Props>()

  const feedbackValue = defineModel<number>()

  const updateValue = (value: number | undefined) => {
    if (feedbackValue.value == value) {
      feedbackValue.value = undefined
    } else {
      feedbackValue.value = value
    }
  }
</script>
